module.exports = __webpack_public_path__ + "static/media/js-logo.e5e47a44.png";